import { isEmpty } from 'lodash';

const getBrandListResponse = (response) => {
  if (isEmpty(response?.brands)) return [];

  const brands = response.brands.map((brand) => {
    return {
      id: brand?.id,
      value: brand?.name,
      label: brand?.name,
    };
  });

  const sortedBrands = brands.sort((a, b) => a.label.localeCompare(b.label));

  return sortedBrands;
};

export default getBrandListResponse;
